<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-09-24 15:07:58
 * @LastEditors: may.li
 * @LastEditTime: 2023-09-25 08:52:53
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import store from '@/store'
export default {
  name: 'App',
  data () {
    return {

    }
  },
  created () {

  },
  computed: {
    ...mapGetters([
      'isupd',
    ])
  },
  watch: {
    '$route': function (curVal) {
      if (this.isupd == 1) {
        this.append();
      }
    }
  },
  methods: {
    append () {
      this.$router.push({
        path: '/base/updpwd'
      })
    },
  }
}
</script>
<style>
	input::-webkit-input-placeholder {
		color: #b2b2b2 !important;
	}

	input::-moz-placeholder {
	/* Mozilla Firefox 19+ */
		color: #b2b2b2 !important;
	}

	input:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
		color: #b2b2b2 !important;
	}

	input:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
		color: #b2b2b2 !important;
	}
</style>